import d from "./index.es297.js";
function a(e) {
  "@babel/helpers - typeof";
  return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, a(e);
}
function f(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function u(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? f(Object(r), !0).forEach(function(n) {
      S(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function S(e, t, r) {
  return (t = O(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function O(e) {
  var t = j(e, "string");
  return a(t) == "symbol" ? t : t + "";
}
function j(e, t) {
  if (a(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (a(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function P(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = h(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function h(e, t) {
  if (e) {
    if (typeof e == "string") return p(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? p(e, t) : void 0;
  }
}
function p(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function E(e, t) {
  var r = t.schema, n = t.getHeaderStyle, l = t.getStyle, b = t.getSharedString, s = t.customFont, g = t.dateFormat;
  if (r) {
    for (var c = [], m = P(r), y; !(y = m()).done; ) {
      var v = y.value;
      if (v.column) {
        c = [r.map(function(o) {
          return u({
            type: String,
            value: o.column,
            align: o.align
          }, n ? n(o) : w);
        })];
        break;
      }
    }
    e = c.concat(e.map(function(o) {
      return r.map(function(i) {
        return u(u(u({}, i), i.getCellStyle ? i.getCellStyle(o) : void 0), {}, {
          value: i.value(o)
        });
      });
    }));
  }
  return e.map(function(o, i) {
    return d(o, i, {
      getStyle: l,
      getSharedString: b,
      customFont: s,
      dateFormat: g,
      usesSchema: r !== void 0
    });
  }).join("");
}
var w = {
  fontWeight: "bold"
};
export {
  E as default
};
//# sourceMappingURL=index.es264.js.map
